const initialState = {
  show: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "MOBILE_FILTER_SHOW":
      return {
        ...state,
        show: action.payload
      };

    case "MOBILE_FILTER_HIDE":
      return {
        ...state,
        show: action.payload
      };

    default:
      return state;
  }
};